import { get } from '@_shared/config';

export class Bridge {
	private ANDROID;

	private IOS;

	constructor() {
		this.ANDROID = window.GabozagoDev || null;
		this.IOS = window.webkit ? window.webkit.messageHandlers.gabozagoDev : null;
	}

	postUUID(uuid: string): void {
		if (this.ANDROID) {
			this.ANDROID.postUUID(uuid);
		}
		if (this.IOS) {
			this.IOS.postMessage({
				action: 'postUUID',
				code: uuid,
			});
		}
	}

	locationAccess(): void {
		if (this.ANDROID) {
			this.ANDROID.locationAccess();
		}
		if (this.IOS) {
			this.IOS.postMessage({
				action: 'locationAccess',
				code: 'locationAccess',
			});
		}
	}

	openMap({
		type,
		name,
		latitude,
		longitude,
	}: {
		type: 'naver' | 'kakao' | 'tmap';
		name: string;
		latitude: number;
		longitude: number;
	}): void {
		switch (type) {
			case 'naver':
				if (this.ANDROID) {
					this.ANDROID.openNaverMap({
						name,
						latitude,
						longitude,
					});
				}
				if (this.IOS) {
					this.IOS.postMessage({
						action: 'openNaverMap',
						code: {
							name,
							latitude,
							longitude,
						},
					});
				}
				break;

			case 'kakao':
				if (this.ANDROID) {
					this.ANDROID.openKakaoMap({
						name,
						latitude,
						longitude,
					});
				}
				if (this.IOS) {
					this.IOS.postMessage({
						action: 'openKakaoMap',
						code: {
							name,
							latitude,
							longitude,
						},
					});
				}
				break;

			case 'tmap':
				if (this.ANDROID) {
					this.ANDROID.openTMap({
						name,
						latitude,
						longitude,
					});
				}
				if (this.IOS) {
					this.IOS.postMessage({
						action: 'openTMap',
						code: {
							name,
							latitude,
							longitude,
						},
					});
				}
				break;

			default:
				break;
		}
	}

	alertAccess(): void {
		if (this.ANDROID) {
			this.ANDROID.alertAccess();
		}
		if (this.IOS) {
			this.IOS.postMessage({
				action: 'alertAccess',
				code: 'alertAccess',
			});
		}
	}

	postVersion(): void {
		get<{ web: string; ios: string; android: string }>('/infra/client-version').then(
			({ data: { web } }) => {
				if (this.ANDROID && this.ANDROID.postVersion) {
					this.ANDROID.postVersion(web);
				}
				if (this.IOS) {
					this.IOS.postMessage({
						action: 'postVersion',
						code: web,
					});
				}
			},
		);
	}
}
